import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

import { api, getEnvironment } from '@springbig/shared';
import TagManager from 'react-gtm-module';

if (process.env.NODE_ENV === 'production' ) {
    const apiEnv = getEnvironment();
    if (apiEnv === 'production') {
        console.log('google tag');
        const tagManagerArgs = {
            gtmId: 'GTM-PDHSZBPG'
        };

        TagManager.initialize(tagManagerArgs);
    }
}

api.unsetHeaders(['app-service']);

(window as any).DEMO_MODE = DEMO_MODE;

// Remove console warnings
// eslint-disable-next-line @typescript-eslint/no-empty-function
console.warn = () => {};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
